// extracted by mini-css-extract-plugin
module.exports = {"btn":"ForwardRepeat_btn__AoXxH","unfilled":"ForwardRepeat_unfilled__1oqMk","filled":"ForwardRepeat_filled__2a6IX"};